import styled from 'styled-components/macro';
import Tooltip from "./tooltip";
import {themecolors} from "../utils/themecolors";

const Moderator = styled.span``;
const Admin = styled.span``;
const OP = styled.span``;
const Pro = styled.span``;
const BasicPro = styled.span``;

const RoleIndicator = styled(({className, admin, mod, op, proTier}) => {
    return (
        <span className={className}>
            {(mod || admin || op || proTier) ? ` ` : ''}
            {mod && <Moderator>Mod </Moderator>}
            {admin && <Admin>Admin </Admin>}
            {op && <OP>OP </OP>}
            {proTier === 1 &&
                    <Tooltip content={"Recently awarded by another user for their post or comment."}>
                        <BasicPro>
                            PRO
                        </BasicPro>
                    </Tooltip>
            }
            {proTier === 2 &&
                <Tooltip content={"Supports the platform with a Pro subscription."}>
                    <Pro>
                            PRO
                    </Pro>
                </Tooltip>
            }
            {` `}
        </span>
    );
})`

  ${Moderator},
  ${Admin},
  ${OP} {
    font-weight: 500;
  }
  ${Moderator} {
    color: #008800;
  }
  ${Admin} {
    color: #c30000;
  }
  ${OP} {
    color: #2086f3;
  }
  ${Pro}, ${BasicPro} {
    border-radius: 2px;
    padding: 2px 4px;
    font-size: 12px;
    margin: 0 2px;
  }
${Pro} {
  background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_5 : themecolors.lighter_border};
  color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  font-size: 10px;
}

${BasicPro} {
  background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_5 : themecolors.lighter_border};
  color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  font-size: 10px;
}
`;

export default RoleIndicator;
